import type { ComponentProps } from "react"
import { SelectScrollUpButton as SelectScrollUpButtonBase } from "@/v2-ui/select/base/SelectBase"
import cn from "@/v2-ui/utils/utils.cn"

export type SelectScrollUpButtonProps = ComponentProps<
  typeof SelectScrollUpButtonBase
>

function SelectScrollUpButton(props: SelectScrollUpButtonProps) {
  const { className, ...selectScrollUpButtonBaseProps } = props
  return (
    <SelectScrollUpButtonBase
      className={cn("ui-select-scroll-up-button", className)}
      {...selectScrollUpButtonBaseProps}
    />
  )
}

export default SelectScrollUpButton
